import { render, staticRenderFns } from "./PFMedia.vue?vue&type=template&id=be970e64&scoped=true&functional=true&"
import script from "./PFMedia.vue?vue&type=script&lang=js&"
export * from "./PFMedia.vue?vue&type=script&lang=js&"
import style0 from "./PFMedia.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PFMedia.vue?vue&type=style&index=1&id=be970e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "be970e64",
  null
  
)

export default component.exports